module.exports = __webpack_public_path__ + "static/img/page_03.b5372b6f.png";